import { useState } from "react";
import { useParams } from "react-router-dom";
import { useGuardedNavigate } from "../../hooks/useGuardedNavigate";
import { Layout, theme, Button } from "antd";
import { FileOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import LoadingOverlay from "react-loading-overlay-ts";

import WysiWygEditor from "../../components/WysiWygEditor";
import { useEditorContext } from "../../hooks/useEditorContext";

import "../../styles/GroupManagement.css";
import AdminTopBar from "../../components/TopBar/AdminTopbar";
import AdminSideBar from "../../components/SideBar/AdminSidebar";

const { Content } = Layout;

const AdminCommunicationPage: React.FC = () => {
  const { groupId }: any = useParams();
  const { editorUpdate } = useEditorContext();

  const [isActive, setActive] = useState(true);
  const navigate = useGuardedNavigate();

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  setTimeout(() => {
    setActive(false);
  }, 1000);

  const handleBack = () => {
    void navigate(`/admin/groups/${groupId}`);
  };

  return (
    <LoadingOverlay active={isActive} spinner>
      <Layout style={{ minHeight: "100vh" }}>
        <AdminSideBar />
        <Layout className="site-layout">
          <AdminTopBar />
          <Content>
            <div
              style={{
                padding: 24,
                minHeight: "100%",
                background: colorBgContainer,
              }}
            >
              <h2>
                <FileOutlined
                  style={{
                    paddingRight: "5px",
                    color: "#f04f05",
                  }}
                />
                {editorUpdate ? "Edit Email Template" : "New Email Template"}
              </h2>
              <div className="interactions">
                <Button onClick={handleBack} size="large">
                  <ArrowLeftOutlined style={{ paddingRight: "5px" }} />
                  Back
                </Button>
              </div>

              <WysiWygEditor groupId={groupId} type={"Communication"} />
            </div>
          </Content>
        </Layout>
      </Layout>
    </LoadingOverlay>
  );
};

export default AdminCommunicationPage;
